export enum FeatureSwitchName {
    Gradebook = 'gradebook',
    Engage = 'engage',
    SelfRegistration = 'self_registration',
    Sso = 'sso',
    Zoom = 'zoom',
    Slack = 'slack',
    ModuleVisibility = 'module_visibility',
    CertificateOfAttendance = 'certificate_of_attendance',
    Community = 'community',
    SurveyIntegration = 'survey_integration',
    ELearning = 'e_learning',
    ClasstimeSections = 'classtime_sections',
    CourseSelfRegistration = 'course_self_registration',
    Reporting = 'reporting',
    BackgroundImage = 'background_image',
    CssSplitting = 'css_splitting',
    CustomDomain = 'custom_domain',
    CourseStructure = 'course_structure',
    Nuggets = 'nuggets',
    UserOnlineState = 'user_online_state',
    PersonalDocuments = 'personal_documents',
    Attendance = 'attendance',
    GrowSearch = 'grow_search',
    TenantDashboard = 'tenant_dashboard',
    Encryption = 'encryption',
    AIImages = 'ai_images',
    PasswordlessLogin = 'passwordless_login',
    ExtendedAttributes = 'extended_attributes',
    Teams = 'teams',
    ParticipantTab = 'participant_tab',
    ParticipantEmailVisibility = 'participant_email_visibility',
    CourseSelfCancellation = 'course_self_cancellation',
    Copyright = 'copyright',
    GlobalCalendar = 'global_calendar',
    WelcomeTour = 'welcome_tour',
    MultiEmails = 'multi_emails',
    Groups = 'groups',
    Chat = 'chat',
    MemberAreaTab = 'member_area_tab',
    ManagerFiles = 'manager_files',
    PersonalDocumentsCopyrightProtection = 'personal_documents_copyright_protection',
    PerformanceFeedbackForm = 'performance_feedback_form',
    CertificateManagement = 'certificate_management',
    CareerModel = 'career_model',
    Qualification = 'qualification',
    RespeakIntegration = 'respeak_integration',
    LearnerProfile = 'learner_profile',
    TrainingApprovalRequest = 'training_approval_request',
    ToDo = 'to_do',
    Beekeeper = 'beekeeper',
    Faq = 'faq',
    BackendUrl = 'backend_url',
    CourseCatalog = 'course_catalog',
    MediaStreamer = 'media_streamer',
    GoogleTagManager = 'google_tag_manager',
    AllModulesTab = 'all_modules_tab',
}
